import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { PrivilegesPartialState } from './privileges.reducer';
import { PrivilegesQuery } from './privileges.selectors';
import * as PrivilegesActions from './privileges.actions';
import { ActionWithCorrelationAttributes } from '@kion/ngrx-helper';
import { Privilege } from '@kion/data-models';

@Injectable()
export class PrivilegesFacade {

  all$ = this.store.pipe(select(PrivilegesQuery.getAllPrivileges));
  allById$ = this.store.pipe(select(PrivilegesQuery.getAllPrivilegesById));
  searchResults$ = this.store.pipe(select(PrivilegesQuery.getSearchResults));
  isSearching$ = this.store.pipe(select(PrivilegesQuery.getIsSearching));
  lastCreatedId$ = this.store.pipe(select(PrivilegesQuery.getLastCreatedId));

  constructor(private store: Store<PrivilegesPartialState>) { }

  protected dispatch(action, correlationId?: string): ActionWithCorrelationAttributes {
    if (correlationId) {
      action.__correlationId = correlationId;
    }
    this.store.dispatch(action);
    return action;
  }

  loadAll(email: string, correlationId?: string): ActionWithCorrelationAttributes {
    return this.dispatch(PrivilegesActions.loadAll({ email: email }), correlationId);
  }
}
